import React from 'react';
import { useDispatch } from 'react-redux';
import { defineMessages, useIntl } from 'react-intl';
import { displayBanner } from 'volto-gdpr-privacy/actions';


import 'volto-gdpr-privacy/components/ShowGdprBanner/show-gdpr-banner.css';

const messages = defineMessages({
    buttonShowLabel: {
        id: 'volto-gdpr-privacy-buttonShowLabel',
        defaultMessage: 'Show cookies settings',
    },
});

const ShowGdprBanner = () => {
    const intl = useIntl();
    const dispatch = useDispatch();

    return (
        <button
            className="gdpr-privacy-show-banner"
            onClick={(e) => {
                e.preventDefault();
                dispatch(displayBanner(true, true));
            }}
        >
            <svg xmlns="http://www.w3.org/2000/svg" width="24" height="25" fill="none" viewBox="0 0 24 25" aria-hidden="true">
            <title>{intl.formatMessage(messages.buttonShowLabel)}</title>
                <mask id="a" width="24" height="25" x="0" y="0" maskUnits="userSpaceOnUse" style={{ maskType: 'luminance' }}><path fill="#fff" d="M0 .667h24v24H0v-24Z" /></mask><g fill="#000" mask="url(#a)"><path d="M22.594 12.667c0 5.85-4.743 10.594-10.594 10.594-5.213 0-9.547-3.767-10.429-8.726l.095.001a4.32 4.32 0 0 0 4.318-4.177c1.14-.33 2.19-1.096 2.897-2.209l.038-.06a5.18 5.18 0 0 0 .769-3.238 4.328 4.328 0 0 0 3.002-2.756c5.53.356 9.904 4.952 9.904 10.57Zm1.406 0C24 6.097 18.72.76 12.17.669a.703.703 0 0 0-.696.551l-.003.016A2.915 2.915 0 0 1 8.82 3.573a.703.703 0 0 0-.629.887c.243.892.114 1.952-.467 2.891l-.028.045c-.624.98-1.581 1.568-2.536 1.706a.703.703 0 0 0-.598.776l.004.042a2.916 2.916 0 0 1-3.592 3.127l-.044-.011a.703.703 0 0 0-.877.745l.007.071c.596 6.071 5.713 10.815 11.94 10.815 6.628 0 12-5.373 12-12Z" /><path d="M8.304 16.65a.879.879 0 1 1-1.758 0 .879.879 0 0 1 1.758 0Z" /><path d="M7.601 16.65a.176.176 0 1 1-.352 0 .176.176 0 0 1 .352 0Zm1.406 0a1.582 1.582 0 1 0-3.164 0 1.582 1.582 0 0 0 3.164 0ZM15.089 7.131a1.406 1.406 0 1 1-2.813 0 1.406 1.406 0 0 1 2.813 0Z" /><path d="M14.386 7.131a.703.703 0 1 1-1.406 0 .703.703 0 0 1 1.406 0Zm1.406 0a2.11 2.11 0 1 0-4.219 0 2.11 2.11 0 0 0 4.219 0ZM17.033 17.654a1.656 1.656 0 1 1-3.312 0 1.656 1.656 0 0 1 3.312 0Z" /><path d="M16.33 17.654a.953.953 0 1 1-1.906 0 .953.953 0 0 1 1.906 0Zm1.406 0a2.36 2.36 0 1 0-4.718 0 2.36 2.36 0 0 0 4.718 0ZM18.778 12.448a.879.879 0 1 1-1.758 0 .879.879 0 0 1 1.758 0Z" /><path d="M18.075 12.448a.176.176 0 1 1-.351 0 .176.176 0 0 1 .351 0Zm1.406 0a1.582 1.582 0 1 0-3.164 0 1.582 1.582 0 0 0 3.164 0Z" /></g>
            </svg>
            <span className="visually-hidden">{intl.formatMessage(messages.buttonShowLabel)}</span>

        </button>
    );
};

export default ShowGdprBanner;
